import { render, staticRenderFns } from "./DetailViewTablePictureView.vue?vue&type=template&id=50ac0170&scoped=true"
import script from "./DetailViewTablePictureView.vue?vue&type=script&lang=js"
export * from "./DetailViewTablePictureView.vue?vue&type=script&lang=js"
import style0 from "./DetailViewTablePictureView.vue?vue&type=style&index=0&id=50ac0170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac0170",
  null
  
)

export default component.exports